module.exports = __webpack_public_path__ + "img/logo.5b68e058.png";